import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
    inputs: {
        width: '100%',
        margin: theme.spacing(1),
    }
}));